<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 23 40"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.5 0L0.5 24H7.5V40L22.5 16H13.7L22.5 0H13.3333H0.5Z" :fill="fill"/>
  </svg>


</template>

<script>
export default {
  name: 'Lightning2',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
